import React from 'react';
import './HeroSection.css';
import heroImage from '../assets/hero-image.jpg'; // Replace with your 1512x493 image path

const HeroSection = () => {
  return (
    <div
      className="hero-section"
      style={{
        background: `url(${heroImage}) no-repeat center center/cover`,
      }}
    >
      <div className="overlay">
        <div className="text-container">
          <h1>
            Welcome to Royal Suites
          </h1>
          <p>Experience luxury living with timeless elegance and comfort.</p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
